import { SignDetectionPanelProps } from './types';

export const useSignDetectionPanel = (props: SignDetectionPanelProps) => {
  const { config, categories, onChange } = props;

  const handleSourceColumnChange = (value: string | null) => {
    onChange({
      ...config,
      sourceColumn: value || '',
    });
  };

  const handleNegativeCategoryChange = (value: string | null) => {
    const selectedId = value || '';
    // Find the other category (the one that's NOT selected)
    const otherCategory = categories.find(c => c.id !== selectedId);

    onChange({
      ...config,
      negativeCategory: selectedId,
      // Auto-populate positive with the other option
      positiveCategory: selectedId ? (otherCategory?.id || '') : '',
    });
  };

  const handlePositiveCategoryChange = (value: string | null) => {
    const selectedId = value || '';
    // Find the other category (the one that's NOT selected)
    const otherCategory = categories.find(c => c.id !== selectedId);

    onChange({
      ...config,
      positiveCategory: selectedId,
      // Auto-populate negative with the other option
      negativeCategory: selectedId ? (otherCategory?.id || '') : '',
    });
  };

  return {
    handleSourceColumnChange,
    handleNegativeCategoryChange,
    handlePositiveCategoryChange,
  };
};
